import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { I18nProvider } from "@/i18n";
import useAudience from "@/hooks/useAudience";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import GiteDetail from "@/pages/GiteDetail";
import Booking from "@/pages/Booking";
import Reviews from "@/pages/Reviews";
import Contact from "@/pages/Contact";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Legal from "@/pages/Legal";
import Validate from "@/pages/Validate";
import Discover from "@/pages/Discover";
import Article from "@/pages/Article";
import PoliceForm from "@/pages/PoliceForm";
import ReviewSubmit from "@/pages/ReviewSubmit";
import ReviewModerate from "@/pages/ReviewModerate";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null)
    return <div className="grid min-h-screen place-items-center text-sm text-muted-foreground">Chargement…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

const Public = ({ children }) => {
  useAudience();
  return <Layout>{children}</Layout>;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <I18nProvider>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Public><Home /></Public>} />
            <Route path="/gite/:slug" element={<Public><GiteDetail /></Public>} />
            <Route path="/reservation" element={<Public><Booking /></Public>} />
            <Route path="/avis" element={<Public><Reviews /></Public>} />
            <Route path="/decouvrir-haut-doubs" element={<Public><Discover /></Public>} />
            <Route path="/decouvrir-haut-doubs/:slug" element={<Public><Article /></Public>} />
            <Route path="/contact" element={<Public><Contact /></Public>} />
            <Route path="/payment/success" element={<Public><PaymentSuccess /></Public>} />
            <Route path="/payment/cancel" element={<Public><PaymentCancel /></Public>} />
            <Route path="/mentions-legales" element={<Public><Legal page="mentions-legales" /></Public>} />
            <Route path="/cgv" element={<Public><Legal page="cgv" /></Public>} />
            <Route path="/annulation" element={<Public><Legal page="annulation" /></Public>} />
            <Route path="/confidentialite" element={<Public><Legal page="confidentialite" /></Public>} />
            <Route path="/valider/:id/:token" element={<Public><Validate /></Public>} />
            <Route path="/avis/nouveau/:token" element={<Public><ReviewSubmit /></Public>} />
            <Route path="/avis/moderation/:id/:token" element={<Public><ReviewModerate /></Public>} />
            <Route path="/fiche-police/:token" element={<Public><PoliceForm /></Public>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Protected><Admin /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </I18nProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
